import React, { useState, useEffect } from "react";
import { Nav } from "../navbar/nav";
import images from "../../constant/images";
import { RiDashboard3Line } from "react-icons/ri";
import { AiOutlineCreditCard } from "react-icons/ai";
import { BiUser } from "react-icons/bi";
import { IoNotificationsOutline } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { storeToken } from "../../formSlice";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { BsDash } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { MdOutlineGroups } from "react-icons/md";

export default function Sidebar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const profile = useSelector((state) => state.gtm.profile);

  const [pages, setPages] = useState([]);
  const lang = useSelector((state) => state.gtm.lang);
  const count = useSelector((state) => state.gtm.count);
  const user =
    useSelector((state) => state.gtm.user) ||
    JSON.parse(localStorage.getItem("user"));
  const membership = user?.membership;
  const pack =
    user?.membership?.status?.trim() === "valid"
      ? user?.membership?.membership_packs
      : null;

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const token = localStorage.getItem("userToken");
  //     try {
  //       if (token) {
  //         const response = await axios.get(`${baseUrl}/user`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         });
  //         setUser(response.data);
  //         setMembership(response.data?.membership);
  //         if (response.data?.membership?.status.trim() === "valid") {
  //           setPack(response.data.membership?.membership_packs);
  //         }
  //         dispatch(storeToken(token));
  //       }
  //     } catch (error) {
  //       // handle error
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [baseUrl, dispatch]);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const platform = "web";
        const response = await axios.get(`${baseUrl}/pages`, {
          params: {
            lang: lang,
            platform: platform,
          },
        });
        setPages(response.data.pages);
      } catch (error) {
        // handle error
      } finally {
        setIsLoading(false);
      }
    };
    fetchPages();
  }, [lang, baseUrl]);

  const logout = async () => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      return navigate("/login");
    }
    try {
      await axios.post(
        `${baseUrl}/logout`,
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
    } catch (err) {
      // handle error
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");
      dispatch(storeToken(null));
      navigate("/login");
    }
  };

  const getProfileBg = () => {
    if (membership?.membership_packs?.profile)
      return membership.membership_packs.profile;
    if (user?.free_pack === 1) return images.Frame;
    return images.visiteur;
  };

  const getProfileColor = () => {
    return membership?.membership_packs?.color || "#608D40";
  };

  // NavLink style helper with dynamic hover color and active color
  const navLinkStyle = ({ isActive }) => ({
    color: isActive ? getProfileColor() : "#000",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    textDecoration: "none",
    fontSize: "15px",
    background: "none",
    transition: "color 0.2s",
    cursor: "pointer",
    width: "100%",
  });

  // Dynamic hover style (now only sets color if not active)
  const dynamicHover = (color, isActive) => ({
    onMouseEnter: (e) => {
      if (!isActive) e.currentTarget.style.color = color;
    },
    onMouseLeave: (e) => {
      if (!isActive) e.currentTarget.style.color = "";
    },
  });

  if (!user) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <div className=" bg-white min-w-[15.5rem] p-10 max-w-[20rem] bg-opacity-[87%] min-h-[80vh] lg:min-h-fit rounded-3xl hidden custom2:block shadow-custom">
      <div className="space-y-16">
        <div className="relative">
          <div className="flex flex-col items-center gap-1">
            <div className="relative">
              <img
                src={getProfileBg()}
                alt=""
                className="h-[120px] w-[200px] md:h-[140px] md:w-[235px]"
              />
              <img
                src={profile ?? user?.photo}
                alt=""
                className="h-[120px] w-[120px] md:h-[135px] md:w-[135px] rounded-full absolute bottom-[5px] left-1/2 -translate-x-1/2"
              />
            </div>
            <div className="flex flex-col text-[17px] items-center gap-8">
              <p
                className="font-bold "
                style={{
                  color: getProfileColor(),
                }}
              >
                {pack
                  ? pack?.name?.charAt(0).toUpperCase() + pack?.name?.slice(1)
                  : "Free"}{" "}
                {t("sideBar.member2")}
              </p>
              {pack?.id !== 3 && (
                <button
                  onClick={() => navigate("/membership/demande")}
                  className={`font-bold px-6 py-2 shadow-md md:px-8 hover:opacity-75 md:py-3 rounded-full text-sm md:text-base ${
                    membership?.membership_packs?.name === "golfer" ||
                    membership?.membership_packs?.name === "golfer+"
                      ? "text-black"
                      : "text-white"
                  }`}
                  style={{
                    backgroundColor: getProfileColor(),
                  }}
                >
                  {t("sideBar.upgrade")}
                </button>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-12">
            <NavLink
              to="/membership/welcome"
              style={navLinkStyle}
              end // <-- Add 'end' to ensure exact match
            >
              {({ isActive }) => (
                <div
                  {...dynamicHover(getProfileColor(), isActive)}
                  style={{
                    color: isActive ? getProfileColor() : "#000",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    width: "100%",
                    transition: "color 0.2s",
                    cursor: "pointer",
                  }}
                >
                  <RiDashboard3Line
                    className="h-6 w-6"
                    style={{ color: "inherit" }}
                  />
                  {t("sideBar.dashboard")}
                </div>
              )}
            </NavLink>
            {user?.membership && user?.membership?.membership_id === 3 && (
              <NavLink to="/membership/members" style={navLinkStyle} end>
                {({ isActive }) => (
                  <div
                    {...dynamicHover(getProfileColor(), isActive)}
                    style={{
                      color: isActive ? getProfileColor() : "#000",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      width: "100%",
                      transition: "color 0.2s",
                      cursor: "pointer",
                    }}
                  >
                    <MdOutlineGroups
                      className="h-6 w-6"
                      style={{ color: "inherit" }}
                    />
                    {t("sideBar.member")}
                  </div>
                )}
              </NavLink>
            )}
            <NavLink
              to="/membership/paiments"
              state={{ userId: user?.id }}
              style={navLinkStyle}
              end
            >
              {({ isActive }) => (
                <div
                  {...dynamicHover(getProfileColor(), isActive)}
                  style={{
                    color: isActive ? getProfileColor() : "#000",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    width: "100%",
                    transition: "color 0.2s",
                    cursor: "pointer",
                  }}
                >
                  <AiOutlineCreditCard
                    className="h-6 w-6"
                    style={{ color: "inherit" }}
                  />
                  {t("sideBar.payments")}
                </div>
              )}
            </NavLink>
            <NavLink
              to="/membership/notification"
              state={{ userId: user?.id }}
              style={navLinkStyle}
              end
            >
              {({ isActive }) => (
                <div
                  {...dynamicHover(getProfileColor(), isActive)}
                  style={{
                    color: isActive ? getProfileColor() : "#000",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    width: "100%",
                    transition: "color 0.2s",
                    cursor: "pointer",
                  }}
                >
                  <IoNotificationsOutline
                    className="h-6 w-6"
                    style={{ color: "inherit" }}
                  />
                  {t("sideBar.notifications")}
                  {count > 0 && (
                    <span className="bg-red-600 rounded-full min-w-[18px] h-[18px] flex items-center justify-center ml-2">
                      <span className="text-[10px] text-white text-center font-bold">
                        {count}
                      </span>
                    </span>
                  )}
                </div>
              )}
            </NavLink>
          </div>
        </div>
        <div className="space-y-4">
          {isLoading ? (
            <div className="flex justify-center items-center h-20">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          ) : (
            pages.map((page) => (
              <NavLink
                key={page.id}
                to={`/membership/${page.route_name}`}
                style={navLinkStyle}
                end
              >
                {({ isActive }) => (
                  <div
                    {...dynamicHover(getProfileColor(), isActive)}
                    style={{
                      color: isActive ? getProfileColor() : "#000",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      width: "100%",
                      transition: "color 0.2s",
                      cursor: "pointer",
                    }}
                  >
                    <BsDash className="h-6 w-6" style={{ color: "inherit" }} />
                    {page.name}
                  </div>
                )}
              </NavLink>
            ))
          )}
          <button
            onClick={logout}
            className="flex items-center font-bold gap-2 text-[15px] hover:text-[#ff0000] mt-2"
            style={{ background: "none" }}
          >
            <FiLogOut className="h-6 w-6" />
            {t("sideBar.logout")}
          </button>
        </div>
      </div>
    </div>
  );
}
